"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.italicCharacters = {
    "A": "𝐴",
    "B": "𝐵",
    "C": "𝐶",
    "D": "𝐷",
    "E": "𝐸",
    "F": "𝐹",
    "G": "𝐺",
    "H": "𝐻",
    "I": "𝐼",
    "J": "𝐽",
    "K": "𝐾",
    "L": "𝐿",
    "M": "𝑀",
    "N": "𝑁",
    "O": "𝑂",
    "P": "𝑃",
    "Q": "𝑄",
    "R": "𝑅",
    "S": "𝑆",
    "T": "𝑇",
    "U": "𝑈",
    "V": "𝑉",
    "W": "𝑊",
    "X": "𝑋",
    "Y": "𝑌",
    "Z": "𝑍",
    "a": "𝑎",
    "b": "𝑏",
    "c": "𝑐",
    "d": "𝑑",
    "e": "𝑒",
    "f": "𝑓",
    "g": "𝑔",
    "h": "ℎ",
    "i": "𝑖",
    "j": "𝑗",
    "k": "𝑘",
    "l": "𝑙",
    "m": "𝑚",
    "n": "𝑛",
    "o": "𝑜",
    "p": "𝑝",
    "q": "𝑞",
    "r": "𝑟",
    "s": "𝑠",
    "t": "𝑡",
    "u": "𝑢",
    "v": "𝑣",
    "w": "𝑤",
    "x": "𝑥",
    "y": "𝑦",
    "z": "𝑧",
    "Α": "𝛢",
    "Β": "𝛣",
    "Γ": "𝛤",
    "Δ": "𝛥",
    "Ε": "𝛦",
    "Ζ": "𝛧",
    "Η": "𝛨",
    "Θ": "𝛩",
    "Ι": "𝛪",
    "Κ": "𝛫",
    "Λ": "𝛬",
    "Μ": "𝛭",
    "Ν": "𝛮",
    "Ξ": "𝛯",
    "Ο": "𝛰",
    "Π": "𝛱",
    "Ρ": "𝛲",
    "ϴ": "𝛳",
    "Σ": "𝛴",
    "Τ": "𝛵",
    "Υ": "𝛶",
    "Φ": "𝛷",
    "Χ": "𝛸",
    "Ψ": "𝛹",
    "Ω": "𝛺",
    "∇": "𝛻",
    "α": "𝛼",
    "β": "𝛽",
    "γ": "𝛾",
    "δ": "𝛿",
    "ε": "𝜀",
    "ζ": "𝜁",
    "η": "𝜂",
    "θ": "𝜃",
    "ι": "𝜄",
    "κ": "𝜅",
    "λ": "𝜆",
    "μ": "𝜇",
    "ν": "𝜈",
    "ξ": "𝜉",
    "ο": "𝜊",
    "π": "𝜋",
    "ρ": "𝜌",
    "ς": "𝜍",
    "σ": "𝜎",
    "τ": "𝜏",
    "υ": "𝜐",
    "φ": "𝜑",
    "χ": "𝜒",
    "ψ": "𝜓",
    "ω": "𝜔",
    "∂": "𝜕",
    "ϵ": "𝜖",
    "ϑ": "𝜗",
    "ϰ": "𝜘",
    "ϕ": "𝜙",
    "ϱ": "𝜚",
    "ϖ": "𝜛"
};
function isItalicCharacter(x) {
    return exports.italicCharacters.hasOwnProperty(x);
}
exports.isItalicCharacter = isItalicCharacter;
exports.translateCharToItalic = function (char) { return isItalicCharacter(char) ? exports.italicCharacters[char] : undefined; };
//# sourceMappingURL=italic.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/latex-to-unicode-converter/ts-compiled/unicode/commands/1args/formatting/italic.js
// module id = 124
// module chunks = 0 1 2 3